import { INIT_TRANSLATIONS } from 'src/constants';

import { messages as messagesUtil } from 'utils';

import { locale } from 'actions/locales';
import { messages } from 'actions/messages';

import progressStore from 'stores/progress';

let isInitialized = false;

async function init() {
  messagesUtil.init();

  if (!messagesUtil.exists()) {
    progressStore.log(INIT_TRANSLATIONS, 'progress');
  }

  const defaultLocale = locale.fetchDefault();

  // In development, check for force refresh flag
  const shouldForceRefresh = process.env.NODE_ENV === 'development' && 
    (localStorage.getItem('force-translation-refresh') === 'true' ||
     new URLSearchParams(window.location.search).get('refreshTranslations') === 'true');

  if (shouldForceRefresh) {
    messages.clearCache();
  }

  // Always try to load fresh translations from cloud first
  // This ensures we get the latest translations when they're updated
  try {
    progressStore.log(INIT_TRANSLATIONS, 'progress');
    await messages.load(defaultLocale);
    isInitialized = true;
    progressStore.log(INIT_TRANSLATIONS, 'completed');
    return;
  } catch (error) {
    console.warn('Failed to load fresh translations, falling back to cache:', error);
    
    // Fallback to cached translations if cloud load fails
    if (await messages.set(defaultLocale)) {
      isInitialized = true;
      progressStore.log(INIT_TRANSLATIONS, 'completed');
      return;
    } else {
      messages.fallback();
      isInitialized = true;
      progressStore.log(INIT_TRANSLATIONS, 'completed');
    }
  }
}

function isInitCompleted() {
  return isInitialized;
}

export { init, isInitCompleted };
